module.exports = "/_next/static/images/2-4b5e47f1e97a7a7e12e036aa13df5b6f.png";